.base {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  border-radius: var(--radius-md);
  border: 1px solid transparent;
  font-weight: var(--weight-medium);
  white-space: nowrap;
  transition:
    background var(--duration-fast) var(--ease-out),
    border-color var(--duration-fast) var(--ease-out),
    color var(--duration-fast) var(--ease-out),
    opacity var(--duration-fast) var(--ease-out);
}

.base:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.fullWidth {
  width: 100%;
}

/* ---- Sizes ---- */
.sm {
  height: 30px;
  padding: 0 var(--space-3);
  font-size: var(--text-sm);
}

.md {
  height: 36px;
  padding: 0 var(--space-4);
  font-size: var(--text-base);
}

.lg {
  height: 44px;
  padding: 0 var(--space-5);
  font-size: var(--text-md);
}

/* ---- Variants ---- */
.primary {
  background: var(--accent);
  color: var(--text-on-accent);
}

.primary:hover:not(:disabled) {
  background: var(--accent-hover);
}

.primary:active:not(:disabled) {
  background: var(--accent-active);
}

.secondary {
  background: var(--bg-surface-raised);
  border-color: var(--border-default);
  color: var(--text-primary);
}

.secondary:hover:not(:disabled) {
  background: var(--bg-hover);
  border-color: var(--border-strong);
}

.ghost {
  background: transparent;
  color: var(--text-secondary);
}

.ghost:hover:not(:disabled) {
  background: var(--bg-hover);
  color: var(--text-primary);
}

.danger {
  background: var(--danger-subtle);
  border-color: var(--danger);
  color: var(--danger);
}

.danger:hover:not(:disabled) {
  background: var(--danger);
  color: var(--text-on-accent);
}

/* ---- Busy state ---- */
.spinner {
  width: 1em;
  height: 1em;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: ela-spin 0.6s linear infinite;
}

.label {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
}

.hidden {
  visibility: hidden;
}

.busyOverlay {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
}

.busy {
  position: relative;
}
